const PRIORITY_RANK = {
  CRITICAL: 4,
  HIGH: 3,
  MEDIUM: 2,
  LOW: 1,
};

export const formatScore = (value) => Number(value || 0).toFixed(1);

export const formatCurrency = (value) => {
  const amount = Number(value || 0);
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(amount);
};

export const sortByPriorityAndUrgency = (items = []) =>
  [...items].sort((a, b) => {
    const pa = PRIORITY_RANK[String(a?.priorityClass || 'LOW').toUpperCase()] || 1;
    const pb = PRIORITY_RANK[String(b?.priorityClass || 'LOW').toUpperCase()] || 1;
    if (pb !== pa) return pb - pa;
    return Number(b?.urgencyScore || 0) - Number(a?.urgencyScore || 0);
  });
